import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';

import errorBoundary from '@ifeng-fe/errorBoundary';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Chip from 'Chip';
import Slides from '@ifeng-fe/ui_pc_slides';
const { formatImage } = require('@ifeng-fe/public_method');

/**
 * 定义 Footer 组件
 */
class ContentSlides extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const config = {
            arrows: true,
            dots: true,
            dotsAction: 'hover',
            autoplay: true,
            autoplayInterval: 6000,
            speed: 1000,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
        };
        let contentSlide = [];

        if (content && content.map) {
            contentSlide = content.map(item => ({
                title: item.title,
                src: item && item.thumbnail ? formatImage(item.thumbnail, 650, 362) : '',
                url: item.url,
            }));
        }

        return (
            <div className={styles.sliderBox}>
                <div className={styles.slide}>
                    <Slides config={config} content={contentSlide} />
                </div>
            </div>
        );
        // return footer;
    }
}

export default errorBoundary(ContentSlides);
